import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { PATH_LOGIN } from 'routing/path'
import { useResetPasswordMutation } from 'actions/admin-user-api';
import { translationApi  } from 'actions/translation-api';
import { showSuccessNotification, showErrorNotification } from "actions/action-complete-notificator";

const ResetPassword = () => {
	const navigate = useNavigate();
	const params = useParams();
	const resetPasswordToken = params.token;

	const [ resetPassword, { isLoading: resetPasswordInProgress }] = useResetPasswordMutation();
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

  if (!resetPasswordToken) {
    navigate(PATH_LOGIN);
    return;
  }

	const submitDisabled = resetPasswordInProgress;
  const handleSubmit = async (fields) => {
    const passwordReset = {
      resetPasswordToken: resetPasswordToken,
      newPassword: fields?.newPassword
    };

    const result = await resetPassword(passwordReset);
    if ('error' in result) {
      showErrorNotification(result.error);
    }
    else {
			showSuccessNotification(translations.changesSaved);
      navigate(PATH_LOGIN);
    }
  };
  
  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required(translations.warningFieldRequired),
    newPasswordConfirmation: Yup.string()
      .required(translations.warningFieldRequired)
      .oneOf([ Yup.ref('newPassword') ], translations.warningValueInvalid)
  });

  const initialValues = {
    newPassword: "",
    newPasswordConfirmation: ""
  };

  const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 5);
  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <div className="container">
            <div className="row justify-content-center form-bg-image">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h1 className="mb-0 h3">Zdefiniuj nowe hasło</h1>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={ async (fields) => { await handleSubmit(fields) }}>
                    { ({ errors, touched }) => (
                      <Form autoComplete={randomAutoComplete}>
                        <div className="form-group mb-4">
                          <label htmlFor="newPassword">{translations.newPassword}</label>
                          <Field id="newPassword" name="newPassword" type="password" className={`form-control ${errors.newPassword && touched.newPassword ? "is-invalid" : ""}`} />
                          <ErrorMessage name="newPassword" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group mb-4">
                          <label htmlFor="newPasswordConfirmation">{translations.passwordConfirmation}</label>
                          <Field id="newPasswordConfirmation" name="newPasswordConfirmation" type="password" className={`form-control ${errors.newPasswordConfirmation && touched.newPasswordConfirmation ? "is-invalid" : ""}`} />
                          <ErrorMessage name="newPasswordConfirmation" component="div" className="invalid-feedback" />
                        </div>
                        <div className="d-grid">
                          <button id="saveButton" type="submit" className="btn btn-dark" disabled={submitDisabled ? 'disabled' : null}>{translations.changePassword}</button>
                        </div>
                      </Form>
                    )}
                  </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default ResetPassword;
